module.exports = __webpack_public_path__ + "media/images/logo_pix_outline-5573165292f84d3f42f2ffda65a7ee6e.svg";